import {Injectable} from '@angular/core';

@Injectable()
export class SearchProfileService {

  private parameters: any = {};

  constructor() {
    let data = localStorage.getItem("parameters-search");
    if (data) {
      this.parameters = JSON.parse(data);
    }
  }

  getParameter(key) {
    return this.parameters[key];
  }

  setParameter(key, value) {
    this.parameters[key] = value;
    localStorage.setItem("parameters-search", JSON.stringify(this.parameters));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/search-profile.service.ts